import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var WalletError = /*#__PURE__*/function (_Error) {
  _inherits(WalletError, _Error);

  var _super = _createSuper(WalletError);

  function WalletError(message, error) {
    var _this;

    _classCallCheck(this, WalletError);

    _this = _super.call(this, message);
    _this.error = error;
    return _this;
  }

  return _createClass(WalletError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Occurs when wallet is not installed.
 */

export var WalletNotFoundError = /*#__PURE__*/function (_WalletError) {
  _inherits(WalletNotFoundError, _WalletError);

  var _super2 = _createSuper(WalletNotFoundError);

  function WalletNotFoundError() {
    var _this2;

    _classCallCheck(this, WalletNotFoundError);

    _this2 = _super2.apply(this, arguments);
    _this2.name = 'WalletNotFoundError';
    _this2.message = 'The wallet is not found.';
    return _this2;
  }

  return _createClass(WalletNotFoundError);
}(WalletError);
/**
 * Occurs when connect to a wallet but there is no wallet selected.
 */

export var WalletNotSelectedError = /*#__PURE__*/function (_WalletError2) {
  _inherits(WalletNotSelectedError, _WalletError2);

  var _super3 = _createSuper(WalletNotSelectedError);

  function WalletNotSelectedError() {
    var _this3;

    _classCallCheck(this, WalletNotSelectedError);

    _this3 = _super3.apply(this, arguments);
    _this3.name = 'WalletNotSelectedError';
    _this3.message = 'No wallet is selected. Please select a wallet.';
    return _this3;
  }

  return _createClass(WalletNotSelectedError);
}(WalletError);
/**
 * Occurs when wallet is disconnected.
 * Used by some wallets which won't connect automatically when call `signMessage()` or `signTransaction()`.
 */

export var WalletDisconnectedError = /*#__PURE__*/function (_WalletError3) {
  _inherits(WalletDisconnectedError, _WalletError3);

  var _super4 = _createSuper(WalletDisconnectedError);

  function WalletDisconnectedError() {
    var _this4;

    _classCallCheck(this, WalletDisconnectedError);

    _this4 = _super4.apply(this, arguments);
    _this4.name = 'WalletDisconnectedError';
    _this4.message = 'The wallet is disconnected. Please connect first.';
    return _this4;
  }

  return _createClass(WalletDisconnectedError);
}(WalletError);
/**
 * Occurs when try to connect a wallet.
 */

export var WalletConnectionError = /*#__PURE__*/function (_WalletError4) {
  _inherits(WalletConnectionError, _WalletError4);

  var _super5 = _createSuper(WalletConnectionError);

  function WalletConnectionError() {
    var _this5;

    _classCallCheck(this, WalletConnectionError);

    _this5 = _super5.apply(this, arguments);
    _this5.name = 'WalletConnectionError';
    return _this5;
  }

  return _createClass(WalletConnectionError);
}(WalletError);
/**
 * Occurs when try to disconnect a wallet.
 */

export var WalletDisconnectionError = /*#__PURE__*/function (_WalletError5) {
  _inherits(WalletDisconnectionError, _WalletError5);

  var _super6 = _createSuper(WalletDisconnectionError);

  function WalletDisconnectionError() {
    var _this6;

    _classCallCheck(this, WalletDisconnectionError);

    _this6 = _super6.apply(this, arguments);
    _this6.name = 'WalletDisconnectionError';
    return _this6;
  }

  return _createClass(WalletDisconnectionError);
}(WalletError);
/**
 * Occurs when call `signMessage()`.
 */

export var WalletSignMessageError = /*#__PURE__*/function (_WalletError6) {
  _inherits(WalletSignMessageError, _WalletError6);

  var _super7 = _createSuper(WalletSignMessageError);

  function WalletSignMessageError() {
    var _this7;

    _classCallCheck(this, WalletSignMessageError);

    _this7 = _super7.apply(this, arguments);
    _this7.name = 'WalletSignMessageError';
    return _this7;
  }

  return _createClass(WalletSignMessageError);
}(WalletError);
/**
 * Occurs when call `signTransaction()`.
 */

export var WalletSignTransactionError = /*#__PURE__*/function (_WalletError7) {
  _inherits(WalletSignTransactionError, _WalletError7);

  var _super8 = _createSuper(WalletSignTransactionError);

  function WalletSignTransactionError() {
    var _this8;

    _classCallCheck(this, WalletSignTransactionError);

    _this8 = _super8.apply(this, arguments);
    _this8.name = 'WalletSignTransactionError';
    return _this8;
  }

  return _createClass(WalletSignTransactionError);
}(WalletError);
/**
 * Occurs when load wallet
 */

export var WalletWalletLoadError = /*#__PURE__*/function (_WalletError8) {
  _inherits(WalletWalletLoadError, _WalletError8);

  var _super9 = _createSuper(WalletWalletLoadError);

  function WalletWalletLoadError() {
    var _this9;

    _classCallCheck(this, WalletWalletLoadError);

    _this9 = _super9.apply(this, arguments);
    _this9.name = 'WalletWalletLoadError';
    return _this9;
  }

  return _createClass(WalletWalletLoadError);
}(WalletError);
/**
 * Occurs when walletconnect QR window is closed.
 */

export var WalletWindowClosedError = /*#__PURE__*/function (_WalletError9) {
  _inherits(WalletWindowClosedError, _WalletError9);

  var _super10 = _createSuper(WalletWindowClosedError);

  function WalletWindowClosedError() {
    var _this10;

    _classCallCheck(this, WalletWindowClosedError);

    _this10 = _super10.apply(this, arguments);
    _this10.name = 'WalletWindowClosedError';
    _this10.message = 'The QR window is closed.';
    return _this10;
  }

  return _createClass(WalletWindowClosedError);
}(WalletError);
/**
 * Occurs when request wallet to switch chain.
 */

export var WalletSwitchChainError = /*#__PURE__*/function (_WalletError10) {
  _inherits(WalletSwitchChainError, _WalletError10);

  var _super11 = _createSuper(WalletSwitchChainError);

  function WalletSwitchChainError() {
    var _this11;

    _classCallCheck(this, WalletSwitchChainError);

    _this11 = _super11.apply(this, arguments);
    _this11.name = 'WalletSwitchChainError';
    return _this11;
  }

  return _createClass(WalletSwitchChainError);
}(WalletError);
/**
 * Occurs when get network infomation.
 */

export var WalletGetNetworkError = /*#__PURE__*/function (_WalletError11) {
  _inherits(WalletGetNetworkError, _WalletError11);

  var _super12 = _createSuper(WalletGetNetworkError);

  function WalletGetNetworkError() {
    var _this12;

    _classCallCheck(this, WalletGetNetworkError);

    _this12 = _super12.apply(this, arguments);
    _this12.name = 'WalletGetNetworkError';
    return _this12;
  }

  return _createClass(WalletGetNetworkError);
}(WalletError);